import React, { useContext, useId } from 'react'
import { MenuContext } from './context/menu-context'
import { MenuKey } from './desktop'
import { generateDropdownClipPath } from './generate-dropdown-clip-path'

interface AltDropdownProps {
    children: React.ReactNode
    caretPosition: number | null
    menuItemKey: MenuKey
    label: string
    gradient: string | undefined
}

export const AltDropdown = ({ children, caretPosition, label, gradient, menuItemKey }: AltDropdownProps) => {
    const clipId = useId().replace(/:/g, '')
    const { handleMouseEnter, handleMouseLeave } = useContext(MenuContext)
    let CONTAINER_WIDTH = 220
    let CONTAINER_HEIGHT = 240
    if (label === 'create') {
        CONTAINER_WIDTH = 210
        CONTAINER_HEIGHT = 78
    } else if (label === 'advertise') {
        CONTAINER_WIDTH = 280
        CONTAINER_HEIGHT = 78
    } else if (label === 'mychannel') {
        CONTAINER_WIDTH = 220
        CONTAINER_HEIGHT = 580
    }
    const CARET_WIDTH = 32
    const CARET_HEIGHT = 16
    const TOTAL_HEIGHT = CONTAINER_HEIGHT + CARET_HEIGHT
    const centeredCaretPosition = CONTAINER_WIDTH / 2

    const pathData = generateDropdownClipPath({
        width: CONTAINER_WIDTH,
        totalHeight: TOTAL_HEIGHT,
        caretHeight: CARET_HEIGHT,
        caretWidth: CARET_WIDTH,
        caretPosition: centeredCaretPosition,
        borderRadius: 6,
    })

    return (
        <div
            onMouseEnter={() => handleMouseEnter(menuItemKey)}
            onMouseLeave={() => {
                handleMouseLeave()
            }}
            className="pointer-events-none absolute  top-full z-modal -translate-x-1/2 -translate-y-1"
            style={{
                left: `${caretPosition}px`,
                width: `${CONTAINER_WIDTH}px`,
                height: label === 'mychannel' ? 'auto' : `${CONTAINER_HEIGHT}px`,
            }}
        >
            <svg width="0" height="0" className="absolute">
                <defs>
                    <clipPath id={clipId}>
                        <path d={pathData} />
                    </clipPath>
                </defs>
            </svg>
            <div
                style={{ background: gradient, clipPath: `url(#${clipId})`, WebkitClipPath: `url(#${clipId})` }}
                className="pointer-events-auto h-full w-full rounded-b-md"
            >
                <div
                    className="h-full w-full"
                    style={{
                        paddingTop: `${CARET_HEIGHT}px`,
                        boxSizing: 'border-box' as const,
                        ...(label === 'mychannel'
                            ? { paddingTop: `${CARET_HEIGHT + 10}px`, paddingBottom: '10px' }
                            : {}),
                    }}
                >
                    <div className="h-full p-2 text-gray-200">{children}</div>
                </div>
            </div>
        </div>
    )
}
